import PropTypes from 'prop-types';
import React from 'react';
import PagerBase from './PagerBase';
import './Pager.less';

function Pager({
    alignLeft,
    alignRight,
    alignCenter,
    hasNext,
    hasPrev,
    navAriaLabel,
    nextAriaLabel,
    nextUrl,
    prevAriaLabel,
    pageCount,
    prevUrl,
    wdioPrefix,
    ...rest
}) {
    return (
        <PagerBase
            navAriaLabel={navAriaLabel}
            nextAriaLabel={nextAriaLabel}
            prevAriaLabel={prevAriaLabel}
            alignLeft={alignLeft}
            alignRight={alignRight}
            alignCenter={alignCenter}
            hasNext={hasNext}
            hasPrev={hasPrev}
            nextUrl={nextUrl}
            prevUrl={prevUrl}
            wdioPrefix={wdioPrefix}
            {...rest}
        >
            {pageCount && <li role="presentation" className="Pager__li Pager__li--page"><span>{pageCount}</span></li>}
        </PagerBase>
    );
}

Pager.propTypes = {
    ...PagerBase.propTypes,
    /** Optional descriptive string to display next to pager. Ex: "1 - 7 of 38". You should not specify it if you are you are using the pageInput feature */
    pageCount: PropTypes.string,
};

Pager.defaultProps = {
    ...PagerBase.defaultProps
};

export default Pager;
